import { cn } from '@quadralize/utils'
import * as React from 'react'
import { LabelWrapper } from '../label/label'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean
  label?: string
  helperText?: React.ReactNode
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, label, helperText, id, required, ...props }, ref) => {
    const generatedId = React.useId()
    const textareaId = id || generatedId

    return (
      <LabelWrapper
        label={label}
        id={textareaId}
        required={required}
        error={error}
        helperText={helperText}
      >
        <textarea
          id={textareaId}
          required={required}
          className={cn(
            'flex min-h-[80px] w-full rounded-md border border-input-border bg-input-bg px-3 py-2 text-sm text-text-primary transition-colors placeholder:text-text-tertiary focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focus-ring disabled:cursor-not-allowed disabled:opacity-50 hover:border-input-border-hover',
            error && 'border-error focus-visible:ring-error',
            className,
          )}
          ref={ref}
          {...props}
        />
      </LabelWrapper>
    )
  },
)
Textarea.displayName = 'Textarea'

export { Textarea }
